import React from "react";
import { observer, inject } from "mobx-react";
import { observable } from "mobx";
import ClearIcon from "@material-ui/icons/Clear";
import SimpleModal from "@src/Components/Common/SimpleModal/SimpleModal";
import { Grid } from "@material-ui/core";
import { Values } from "@src/Tools/Values";
import { STButton, STText, STGrid } from "./styles";
import RestoreIcon from "@material-ui/icons/Restore";
import { STButtonMargin } from "@src/Components/Ui/STButtonMargin";
import { STTypography } from "@src/Components/Common/EntityDelete/styles";
import ManagementStore from "@src/Stores/Management";
import { Toast } from "@src/Tools/Toast";

interface IProps {
  management?: ManagementStore;
}

@inject("management")
@observer
export default class CreateDatabaseBackup extends React.Component<IProps> {
  @observable isOpened: boolean = false;
  private toast = new Toast();

  handleCreateDatabaseBackup = async () => {
    const databaseName = await this.props.management.createDatabaseBackup();
    this.handleClose();
    this.toast.showSuccess(Values.getLocalizationValue("databaseBackupSaved").replace("{0}", databaseName));
  };

  handleOpen = () => {
    this.isOpened = true;
  };

  handleClose = () => {
    this.isOpened = false;
  };

  render() {
    return (
      <React.Fragment>
        <div>
          <STButton variant="contained" onClick={this.handleOpen}>
            <RestoreIcon />
            <STText>{Values.getLocalizationValue("createDatabaseBackup")}</STText>
          </STButton>
        </div>

        <SimpleModal width={500} isOpened={this.isOpened} onClose={this.handleClose}>
          <STGrid container direction="column" justify="space-between" alignItems="center">
            <STTypography>{Values.getLocalizationValue("areYouSureCreateDatabaseBackup")}</STTypography>
            <Grid container justify="center" wrap="nowrap">
              <STButtonMargin onClick={this.handleCreateDatabaseBackup} variant="contained" color="primary">
                <RestoreIcon />
              </STButtonMargin>
              <STButtonMargin onClick={this.handleClose} variant="contained">
                <ClearIcon />
              </STButtonMargin>
            </Grid>
          </STGrid>
        </SimpleModal>
      </React.Fragment>
    );
  }
}
